module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_external_link-a06e2b89a0113c04ee4f63cf4f3e36c2.svg";